import { createContext } from "react";
import type { User } from "firebase/auth";

export type AuthState = {
  user: User | null;
  loading: boolean;
  getIdToken: () => Promise<string | null>;
};

export const AuthContext = createContext<AuthState | null>(null);
